<ng-container *ngIf="isOpen">
  <div class="alert" [ngClass]="'alert--' + intent">
    <div class="alert__type-indicator">
      <cp-icon [type]="intentIcon"></cp-icon>
    </div>
    <div class="alert__content">
      <div class="alert__header">
        <div class="alert__message">
          <p class="alert__description" [ngClass]="{ 'alert__description--popover': isPopOver == true }">
            <ng-content></ng-content>
          </p>
        </div>
      </div>
    </div>

    <button class="alert__close-button" *ngIf="hasCloseButton" (click)="customClose()">
      <cp-icon type="close-xs"></cp-icon>
    </button>
  </div>
</ng-container>
